import { all, takeLatest } from 'redux-saga/effects';
import { FETCH_TERMS_REQUEST } from './constants';
import { fetchTermsSuccess, fetchTermsFailure } from './actions';
import { apiSaga } from 'sagas';
import { getTerms } from 'utils/api';

export function* termsFlow() {
  yield* apiSaga(getTerms, [], fetchTermsSuccess, fetchTermsFailure);
}

export default function* watchTerms() {
  yield all([
    takeLatest(FETCH_TERMS_REQUEST, termsFlow),
  ]);
}



// WEBPACK FOOTER //
// ./src/containers/TermsPage/sagas.js